import PartnerHero from './PartnerHero';
import Segment from './Segment'
import './style.css';
import PartnerCard from './PartnerCard'
import { GetHiringCategory } from '../../actions';
import { connect } from 'react-redux';
import { useEffect } from 'react';
import { BASE_URL  } from '../../variables'
import LazyLoadImage from '../utils/LazyLoadImage'
const BecomeAPartner = ({ GetHiringCategory, hiring }) => {
    useEffect(() => {
        GetHiringCategory()
    }, [GetHiringCategory])
    const renderHiring = hiring.map(x => {
        return (
            <div key={x.id} className="hiring-item">
                <div className="icon">
                    {/* <img src={BASE_URL + x.icon} alt="hiring" /> */}
                    <LazyLoadImage height="50px" width="50px" src={BASE_URL + x.icon} alt="hiring"/>
                </div>
                <div className="name">{x.name}</div>
            </div>
        )
    })
    return (
        <div>
            <PartnerHero />
            <Segment>
                <div className="ui container partner-container max-width partner-hero-container" style={{display: 'block'}}>
                    <div style={{textAlign: 'center'}}>
                        <h1 className="main-title">Join CoreCare to change your life</h1>
                        <p className="description">CoreCare is an app-based marketplace that empowers professionals like you to become your own boss.</p>
                    </div>
                    <div className="stats">
                        <div className="stats-item">
                            <h1>30,000+</h1>
                            <p>Partners already onboard</p>
                        </div>
                        <div className="stats-item">
                            <h1>&#8377; 566Cr</h1>
                            <p>Paid out to partnet in 2020</p>
                        </div>
                        <div className="stats-item">
                            <h1>250,000+</h1>
                            <p>Service delivered every month</p>
                        </div>
                    </div>
                    <PartnerCard heading="Wondering who can join?" subheading="If you have 1 year of experiance in any of these fields you can join CoreCare.">
                        <div className="hiring-section">
                            {renderHiring}
                        </div>
                    </PartnerCard>
                </div>
            </Segment>
        </div>
    )
}
const mapStateToProps = (state) => {
    return {
        hiring: state.hiring
    }
}
export default connect(mapStateToProps, { GetHiringCategory })(BecomeAPartner)